"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToLocalIso = exports.formatTimeSince = exports.tomorrow = exports.formatSummaryRangeWithLabel = exports.daysInRange = exports.formatRowDate = exports.formatHeadingDateRange = exports.formatDateToIso = exports.formatDate = exports.getFormattedEndDate = void 0;
var date_fns_1 = require("date-fns");
var getFormattedEndDate = function (periodEndDate) {
    var now = new Date();
    return periodEndDate
        ? (0, date_fns_1.format)(periodEndDate, 'd MMMM')
        : (0, date_fns_1.format)((0, date_fns_1.endOfMonth)(now), 'd MMMM');
};
exports.getFormattedEndDate = getFormattedEndDate;
var formatDate = function (date, formatString) {
    if (formatString === void 0) { formatString = 'do MMMM'; }
    return (0, date_fns_1.format)(new Date(date), formatString);
};
exports.formatDate = formatDate;
var formatDateToIso = function (date) {
    return new Date(date).toISOString();
};
exports.formatDateToIso = formatDateToIso;
/**
 * If range is whole month or day in a month return firstPartDisplay,
 * otherwise firstPartDisplay is start date, secondPartDisplay is end date.
 */
function formatDateRange(startDate, endDate) {
    var fromDayOfMonth = (0, exports.formatDate)(startDate, 'do');
    var fromMonth = (0, exports.formatDate)(startDate, 'MMMM');
    var fromYear = (0, exports.formatDate)(startDate, 'yyyy');
    var toDayOfMonth = (0, exports.formatDate)(endDate, 'do');
    var toMonth = (0, exports.formatDate)(endDate, 'MMMM');
    var toYear = (0, exports.formatDate)(endDate, 'yyyy');
    if (fromMonth === toMonth && fromYear === toYear) {
        // Same month
        if ((0, date_fns_1.isFirstDayOfMonth)(startDate) && (0, date_fns_1.isLastDayOfMonth)(endDate)) {
            return { firstPartDisplay: "".concat(fromMonth, " ").concat(fromYear) };
        }
        else if (fromDayOfMonth === toDayOfMonth) {
            return { firstPartDisplay: "".concat(fromDayOfMonth, " ").concat(fromMonth, " ").concat(fromYear) };
        }
        else {
            return {
                firstPartDisplay: "".concat(fromDayOfMonth),
                secondPartDisplay: "".concat(toDayOfMonth, " ").concat(fromMonth, " ").concat(fromYear),
            };
        }
    }
    else if (fromYear === toYear) {
        // Same year
        return {
            firstPartDisplay: "".concat(fromDayOfMonth, " ").concat(fromMonth),
            secondPartDisplay: "".concat(toDayOfMonth, " ").concat(toMonth, " ").concat(fromYear),
        };
    }
    else {
        // Different year
        return {
            firstPartDisplay: "".concat(fromDayOfMonth, " ").concat(fromMonth, " ").concat(fromYear),
            secondPartDisplay: "".concat(toDayOfMonth, " ").concat(toMonth, " ").concat(toYear),
        };
    }
}
function formatHeadingDateRange(startDate, endDate, excludeYear) {
    var fromDayOfMonth = (0, exports.formatDate)(startDate, 'd');
    var fromMonth = (0, exports.formatDate)(startDate, 'MMM');
    var fromYear = (0, exports.formatDate)(startDate, 'yyyy');
    var toDayOfMonth = (0, exports.formatDate)(endDate, 'd');
    var toMonth = (0, exports.formatDate)(endDate, 'MMM');
    var toYear = (0, exports.formatDate)(endDate, 'yyyy');
    if (fromYear === toYear) {
        if (fromMonth === toMonth) {
            return {
                startDate: "".concat(fromDayOfMonth),
                endDate: "".concat(toDayOfMonth, " ").concat(toMonth, " ").concat(!excludeYear ? fromYear : ''),
            };
        }
        return {
            startDate: "".concat(fromDayOfMonth, " ").concat(fromMonth),
            endDate: "".concat(toDayOfMonth, " ").concat(toMonth, " ").concat(!excludeYear ? fromYear : ''),
        };
    }
    else {
        return {
            startDate: "".concat(fromDayOfMonth, " ").concat(fromMonth, " ").concat(!excludeYear ? fromYear : ''),
            endDate: "".concat(toDayOfMonth, " ").concat(toMonth, " ").concat(!excludeYear ? toYear : ''),
        };
    }
}
exports.formatHeadingDateRange = formatHeadingDateRange;
var formatRowDate = function (date) { return (0, exports.formatDate)(date, 'd MMM'); };
exports.formatRowDate = formatRowDate;
function daysInRange(start, end) {
    return Math.abs((0, date_fns_1.differenceInCalendarDays)(start, end)) + 1;
}
exports.daysInRange = daysInRange;
function formatSummaryRangeWithLabel(start, end) {
    var dateRange = formatDateRange(start, end);
    // Add label for accessibility if date in 2 parts
    if (dateRange.secondPartDisplay) {
        return {
            display: "".concat(dateRange.firstPartDisplay, " \u2013 ").concat(dateRange.secondPartDisplay),
            accessibleLabel: "".concat(dateRange.firstPartDisplay, " to the ").concat(dateRange.secondPartDisplay),
        };
    }
    else {
        return {
            display: dateRange.firstPartDisplay,
        };
    }
}
exports.formatSummaryRangeWithLabel = formatSummaryRangeWithLabel;
function tomorrow(date) {
    return (0, date_fns_1.format)((0, date_fns_1.addDays)(new Date(date), 1), 'yyyy-MM-dd');
}
exports.tomorrow = tomorrow;
function formatTimeSince(time) {
    var now = Date.now();
    var diffInMins = (0, date_fns_1.differenceInMinutes)(now, time);
    if (diffInMins < 60) {
        return "".concat(diffInMins, "m");
    }
    var diffInHours = (0, date_fns_1.differenceInHours)(now, time);
    if (diffInHours < 24) {
        return "".concat(diffInHours, "h");
    }
    return "".concat((0, date_fns_1.differenceInDays)(now, time), "d");
}
exports.formatTimeSince = formatTimeSince;
var dateToLocalIso = function (date) {
    return (0, date_fns_1.format)(date, "yyyy-MM-dd'T'HH:mm:ss");
};
exports.dateToLocalIso = dateToLocalIso;
